import { FETCH_QUERIES_NAME, MUTATION_KEYS } from '@common/constants';
import { AxiosErrorResponse } from '@core/error.models';
import { useMutation, useQuery } from '@tanstack/react-query';
import { IPagedResultsV1 } from '@gcl/react-core';
import {
  IDeleteProjectMasterScheduleTagRequest,
  IProjectMasterScheduleTagBase,
  IProjectMasterScheduleTagsSearchRequest,
  IUpdateProjectMasterScheduleTagRequest,
} from './masterScheduleTag.models';
import {
  deleteProjectMasterScheduleTagsSearchAsync,
  getProjectMasterScheduleTagsSearchAsync,
  putProjectMasterScheduleTagsSearchAsync,
} from './masterScheduleTag.services';

export const useFetchProjectMasterScheduleTagSearch = (
  props: IProjectMasterScheduleTagsSearchRequest,
  enabled = true,
) => {
  return useQuery<IProjectMasterScheduleTagBase[], AxiosErrorResponse>(
    [props.projectId, FETCH_QUERIES_NAME.MASTER_SCHEDULE_TAGS_SEARCH, props.text],
    async () => {
      const results = await getProjectMasterScheduleTagsSearchAsync(props);
      return results.items ?? [];
    },
    {
      enabled,
    },
  );
};

export const useUpdateProjectMasterScheduleTag = () => {
  return useMutation<
    IPagedResultsV1<IProjectMasterScheduleTagBase>,
    AxiosErrorResponse,
    IUpdateProjectMasterScheduleTagRequest
  >([MUTATION_KEYS.UPDATE_MASTER_SCHEDULE_TAGS], async (request: IUpdateProjectMasterScheduleTagRequest) => {
    const result = await putProjectMasterScheduleTagsSearchAsync(request);
    return result;
  });
};

export const useDeleteProjectMasterScheduleTag = () => {
  return useMutation<boolean, AxiosErrorResponse, IDeleteProjectMasterScheduleTagRequest>(
    [MUTATION_KEYS.DELETE_MASTER_SCHEDULE_TAGS],
    async (request: IDeleteProjectMasterScheduleTagRequest) => {
      const result = await deleteProjectMasterScheduleTagsSearchAsync(request);
      return result;
    },
  );
};
